import styles from "./square.module.css"

export default function Square1160() {
  return <div className={styles.square1160}></div>
}
